@import '../../../../../../../../constants/spacing.module.less';

.mapping-dropdown {
  width: 50%;
}

.dropdown-container {
  gap: @space-24;
  margin-bottom: @space-24;
}

.dropdown-wrapper {
  flex: 1;
}

.dropdown-title {
  font-size: 16px;
  margin-top: @space-24;
}

.dropdown-menu {
  margin-top: @space-4;
}
